import React, { Component } from "react";
import ApiRequest from "../libs/request.js";
import { FaLock, FaMailBulk } from "react-icons/fa";

class UpdatePassword extends Component {
  constructor(props) {
    super(props);
    this.password = React.createRef();
    this.confirmPassword = React.createRef();
    this.vCode = React.createRef();
    this.errorsPanel = React.createRef();
    this.state = { success: false, isLoading: false };
  }

  verifyCode() {
    const searchParams = new URLSearchParams(window.location.search);
    const email = searchParams.get("email");
    const code = this.vCode.current.value;
    let params = { email, code };
    let apiRequest = new ApiRequest("post", "/user/verify-code");
    apiRequest.send(params, (response) => {
      let result = response;
      console.log("result: ", result);
      try {
        if (result.errors) {
          // Handle verification error
          if (result.message == "Un-verified") {
            // Handle unverified account
            this.errorsPanel.current.innerHTML = "Invalid verification code or code expired. Please request a new code.";
          } else {
            this.errorsPanel.current.innerHTML = result.message;
          }
        } else {
          // Verification successful
          this.setState({ success: true });
          // Save token to state
          this.setState({ token: result.data.token });

          setTimeout(() => {
            this.handleUpdatePassword();
          }, 1000);
        }
      } catch (e) {
        // Handle api request error
        console.log("error: ", e);
      }
    });
  }

  render() {
    const successMessage = this.state.success && (
      <div className="update-success-message">
        <span>✓ Verification Successful</span>
        <p style={{ marginTop: "8px", fontSize: "14px" }}>
          Updating your password...
        </p>
      </div>
    );

    return (
      <React.Fragment>
        <div className="update-password-container">
          <div className="update-password-content">
            {/* Left Intro Panel */}
            <div className="update-intro-panel">
              <h2 className="update-intro-title">
                Secure Your Account
              </h2>
              <p className="update-intro-subtitle">
                Update your password to keep your FilmFuse account safe and secure
              </p>

              {/* Features */}
              <div className="update-features">
                <div className="update-feature-item">
                  <FaLock className="update-feature-icon" />
                  <div>
                    <h4>Secure Process</h4>
                    <p>Your password is encrypted and secure</p>
                  </div>
                </div>
                <div className="update-feature-item">
                  <FaMailBulk className="update-feature-icon" />
                  <div>
                    <h4>Email Verification</h4>
                    <p>Verify with code sent to your email</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Panel */}
            <div className="update-form-panel">
              <div className="update-form-card">
                <img
                  src="/images/filmfuse-logo.png"
                  className="update-form-logo"
                  alt="FilmFuse"
                />

                <h1 className="update-form-title">Update Password</h1>
                <p className="update-form-subtitle">
                  Enter your verification code and new password
                </p>

                {/* Error Panel */}
                <div
                  className="update-error-panel"
                  ref={this.errorsPanel}
                  style={{ display: "none" }}
                ></div>

                {/* Success Message */}
                {successMessage}

                <form className="update-form">
                  <div className="update-form-group">
                    <label>Verification Code *</label>
                    <input
                      type="text"
                      placeholder="Enter code from email"
                      ref={this.vCode}
                      className="update-form-input"
                    />
                    <small className="update-form-hint">
                      Check your email for the verification code we sent you
                    </small>
                  </div>

                  <div className="update-form-group">
                    <label>New Password *</label>
                    <input
                      type="password"
                      placeholder="Enter new password"
                      ref={this.password}
                      className="update-form-input"
                    />
                  </div>

                  <div className="update-form-group">
                    <label>Confirm Password *</label>
                    <input
                      type="password"
                      placeholder="Confirm your password"
                      ref={this.confirmPassword}
                      className="update-form-input"
                    />
                  </div>

                  <button
                    className="update-btn"
                    onClick={this.verifyCode.bind(this)}
                    disabled={this.state.isLoading}
                    type="button"
                  >
                    {this.state.isLoading ? "Updating..." : "Update Password"}
                  </button>

                  <div className="update-form-footer">
                    Didn't receive code?{" "}
                    <a href="/reset" className="update-link">
                      Send Again
                    </a>
                    <br />
                    Remember password?{" "}
                    <a href="/login" className="update-link">
                      Go to Login
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleUpdatePassword() {
    const password = this.password.current.value;
    const confirmPassword = this.confirmPassword.current.value;
    if (password !== confirmPassword) {
      this.errorsPanel.current.innerHTML = "Passwords do not match";
      this.errorsPanel.current.style.display = "block";
      return;
    }

    const { token } = this.state;
    if (!token) {
      // Handle token not found
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const email = searchParams.get("email");
    let params = { email, password, confirm_password: confirmPassword, token };
    let apiRequest = new ApiRequest("post", "/user/update-password");
    apiRequest.send(params, (response) => {
      let result = response?.data || response;
      if (result.errors) {
        // Handle update password error
        this.errorsPanel.current.innerHTML = result.message;
        this.errorsPanel.current.style.display = "block";
      } else {
        window.location.href = "/login";
        // Password updated successfully
        // Redirect to login page or any other page
      }
    });
  }
}

export default UpdatePassword;

// export default UpdatePassword;
